import React from 'react';
import { View, Text, ViewStyle, TouchableWithoutFeedback } from 'react-native';
import { styles } from './style';
import { styles as stylesFn } from '@/common/style';
import Image from '@kds/image';
import Flex from '@/component/atom/Flex';
import { Stepper } from '@/component/Stepper/Stepper';
// import { ReturnT } from '../../hooks/usePageInfo';
import { $k18n } from '@/common/i18n';
import { openUrl } from '@/common/bridge/openUrl';
import { getKrnDomain } from '@/common/api';
import queryString from 'query-string';
import { isIOS } from '@kibt/krn-utils';
import { useCountDown } from './hooks';
import { useQuery } from '../hooks/useGetStoreCartItem';
import { useQuerys } from '@/hooks/useQuery';
import { Toast } from '@kibt/meta-ui-krn';
// type CartShopItem = ReturnT['cartShopList'][number];

interface IProps {
    pruductItem?: any;
    style?: ViewStyle;
    onSkuNumChange?: (num: number, type?: 0 | 1) => void;
    onGoDetail?: () => void;
    disabled?: boolean;
}

const TextMap = () => ({
    2: $k18n('已下架'),
    3: $k18n('库存不足'),
    4: $k18n('已抢光'),
});

const ProductCard = (props: IProps) => {
    const { style, pruductItem, onSkuNumChange, onGoDetail, disabled = false } = props;
    const { query } = useQuery();
    const underlinePrice = pruductItem?.showPrice?.origin;
    const { env } = useQuerys();

    function goDetail() {
        onGoDetail?.();
        const urls = [
            // 如果是kwai的商品详情页，需要转成一码多投链接
            'm-shop.kwai.com/shop/c/detail',
            'm-shop.staging.kuaishou.com/shop/c/detail',
            'm-shop.prt.kuaishou.com/shop/c/detail',
            'm-shop.kwai.com/krn-web/detail',
            'm-shop.staging.kuaishou.com/krn-web/detail',
            'm-shop.prt.kuaishou.com/krn-web/detail',
        ];
        const itemId = pruductItem.itemId;
        console.log('pruductItem', JSON.stringify(pruductItem));
        const iosParams = isIOS
            ? {
                  foldRatio: 0.75, // iosrn 新增跳转参数
                  openSlideFullScreen: 1, // iosrn 新增跳转参数 表明是可拖拽的半屏
                  isHalf: 1, // iosrn 新增跳转参数
              }
            : {};
        const krnUrl = queryString.stringify(
            {
                bundleId: 'Detail',
                componentName: 'Detail',
                env,
                cornerRadius: 16,
                __launch_options__: null,
                hyId: null,
                height: '0.75h',
                ...iosParams,
            },
            { sort: false, skipNull: true },
        );
        const url = queryString.stringifyUrl({
            url: `${getKrnDomain()}/krn-web/detail`,
            query: {
                hyId: 'kibt-fe-shop-c-krn',
                cornerRadius: 16,
                redirectUrl: krnUrl,
                extParams: JSON.stringify({
                    cT: 51,
                    cId: (query as any)?.itemId,
                }),
                itemId,
            },
        });
        openUrl({ url, halfWebview: true });
    }

    const { flashSaleCountDownStr } = useCountDown(pruductItem);

    return (
        <Flex style={{ flex: 1, ...style }} flex={['flexRow']}>
            <TouchableWithoutFeedback onPress={goDetail}>
                <View style={styles.imageBox}>
                    <Image style={styles.img} source={{ uri: pruductItem?.skuImageUrl ?? pruductItem?.itemImageUrl }} />
                    {disabled ? (
                        <Flex
                            flex={'flexCenter'}
                            style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, backgroundColor: 'rgba(0,0,0,0.6)' }}
                        >
                            <Text style={stylesFn({ textAlign: 'center', color: '#fff' })}>{TextMap()[pruductItem.status]}</Text>
                        </Flex>
                    ) : null}
                </View>
            </TouchableWithoutFeedback>
            <Flex style={{ flex: 1 }} flex={['flexColBtw']}>
                <TouchableWithoutFeedback onPress={goDetail}>
                    <View>
                        <Text numberOfLines={2} ellipsizeMode="tail" style={stylesFn({ color: '#000' })}>
                            {pruductItem?.title}
                        </Text>
                        {pruductItem.status === 2 ? null : (
                            <Text
                                numberOfLines={1}
                                ellipsizeMode="tail"
                                style={stylesFn({ marginTop: 12, marginRight: 8, color: 'rgba(0,0,0,0.4)' })}
                            >
                                {pruductItem.skuSpecDesc}
                            </Text>
                        )}
                    </View>
                </TouchableWithoutFeedback>

                {[2, 4].indexOf(pruductItem.status) > -1 ? null : (
                    <Flex style={{ marginTop: 15 }} className={'content-bottom'} flex={'flexBtw'}>
                        <Flex style={{ flex: 1, marginRight: 8 }} className={'price'} flex={'flexCol'}>
                            {underlinePrice?.amount ? <Text style={styles.underlinePrice}>{underlinePrice?.displayAmount}</Text> : null}
                            <Text style={[styles.price, underlinePrice ? styles.textRed : styles.textBlack]}>
                                {pruductItem?.showPrice?.now?.displayAmount}
                            </Text>
                        </Flex>

                        <Stepper
                            fallbackWhenEmpty={true}
                            min={1}
                            max={pruductItem.skuQuantityLimit}
                            value={pruductItem.skuQuantity}
                            onChange={onSkuNumChange}
                            onPlus={(num) => onSkuNumChange(num, 0)}
                            onMinus={(num) => onSkuNumChange(num, 1)}
                            disableText={true}
                            onOverLimit={(type) => {
                                if (type === 'minus') {
                                    Toast.show({ text: $k18n('最少购买1件') });
                                } else {
                                    Toast.show({ text: $k18n({ text: '最多购买{num}件', params: { num: pruductItem.skuQuantityLimit } }) });
                                }
                            }}
                        />
                    </Flex>
                )}

                {flashSaleCountDownStr ? (
                    <Flex>
                        <Text style={styles.timeoutStr}>{$k18n({ id: '', text: '' }) + flashSaleCountDownStr}</Text>
                    </Flex>
                ) : (
                    <></>
                )}
            </Flex>
        </Flex>
    );
};

export default ProductCard;
